<template>
  <v-app :style="`background-color: ${bgcolor}`">
    <v-main class="Kanit">
      <!-- <v-scroll-x-transition>
        <v-icon v-if="task.done" color="success"> mdi-check </v-icon>
      </v-scroll-x-transition> -->

      <transition
        name="fade"
        mode="out-in"
        @beforeLeave="beforeLeave"
        @enter="enter"
        @afterEnter="afterEnter"
      >
        <router-view />
      </transition>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  components: {},

  data: () => ({
    prevHeight: 0
  }),
  methods: {
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height
    },
    enter(element) {
      const { height } = getComputedStyle(element)

      element.style.height = this.prevHeight

      setTimeout(() => {
        element.style.height = height
      })
    },
    afterEnter(element) {
      element.style.height = 'auto'
    }
  },
  computed: {
    bgcolor() {
      return this.$store.state.bgcolor
    }
  }
}
</script>
<style>
* {
  box-sizing: border-box;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.2s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.Kanit {
  font-family: 'Kanit', sans-serif !important;
}
</style>
